<template>
  <BaseDialog
    :isOpen="isOpen"
    :title="title"
    @close="$emit('close')"
    @cancel="$emit('cancel')"
    @confirm="onConfirm"
    :hidePrimaryBtn="!canEdit"
  >
    <v-form :readonly="!canEdit" lazy-validation ref="upsertAbortionDialog">
      <v-card-text>
        <p class="mb-2 text-subtitle-1">Thông tin cơ bản</p>
        <div class="pl-2">
          <autocomplete-student
            v-model="formData.student"
            label="Tìm kiếm học sinh"
            dense
            return-object
            class="pt-4"
            :rules="[$rules.required]"
            v-if="!isEdit && !fixedStudent"
          />
          <date-selector
            :disabled="!canEdit"
            label="Ngày thôi học"
            :rules="[$rules.required]"
            :date="transformDateForDatePicker(formData.abortion_date)"
            @change="onAbortionDateChange"
          ></date-selector>
          <v-select
            :items="reasonTypeOptions"
            item-value="value"
            item-title="text"
            v-model="formData.reason_type"
            label="Lí do thôi học"
          >
          </v-select>
          <v-text-field label="Chi tiết lý do" v-model="formData.reason"></v-text-field>
          <v-select
            label="Tình trạng học phí"
            :items="tuitionStatusOptions"
            item-value="value"
            item-title="text"
            v-model="formData.tuition_status"
          >
          </v-select>
          <v-checkbox
            v-model="formData.forced_abortion"
            label="Bắt buộc thôi học"
            color="red"
          ></v-checkbox>
          <v-checkbox
            v-model="formData.tuition_refunded"
            label="Đã hoàn học phí"
            color="green"
          ></v-checkbox>
          <v-text-field label="Tài liệu" v-model="formData.document"></v-text-field>
          <v-textarea rows="3" label="Ghi chú" v-model="formData.note"></v-textarea>
        </div>
      </v-card-text>
    </v-form>
  </BaseDialog>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog'
import DateSelector from '@/components/basic/DateSelector.vue'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import {
  reasonTypeOptions,
  transformDateForDatePicker,
  tuitionStatusOptions
} from '../helpers'

export default {
  components: {
    DateSelector,
    AutocompleteStudent,
    BaseDialog
  },
  data() {
    return {
      formData: cloneDeep(this.currentItem)
    }
  },
  props: {
    currentItem: Object,
    isOpen: Boolean,
    isEdit: Boolean,
    fixedStudent: Boolean
  },
  computed: {
    reasonTypeOptions,
    tuitionStatusOptions,
    ...mapState('auth', ['profile', 'role']),
    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },

    title() {
      if (this.isEdit) {
        return 'Cập nhật thôi học'
      }
      return 'Tạo mới thôi học'
    }
  },
  methods: {
    transformDateForDatePicker,
    onAbortionDateChange(value) {
      this.formData.abortion_date = moment(value, 'YYYY-MM-DD').toISOString()
    },
    formatDateField(v) {
      if (!v) {
        return v
      }
      return moment(v).format('DD/MM/YYYY')
    },
    onConfirm() {
      if (this.$refs.upsertAbortionDialog.validate()) {
        this.$emit('confirm', this.formData)
      }
    }
  }
}
</script>
